import React, { useEffect, useState } from 'react';
import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import { Link } from 'react-router-dom';
import "./PendingCartOrderNew.css";
import { FaAngleDoubleDown, FaAngleDoubleUp } from 'react-icons/fa';
import ProgressBar from '../../CheckOut/components/ProgressBar';
import "swiper/swiper-bundle.min.css";
import { Swiper, SwiperSlide } from "swiper/react";
const PendingCartOrderNew = ({ restaurant }) => {
  const [total, setTotal] = useState(0);
  const [showAll, setShowAll] = useState(false);
  const [appropiateStatus, setAppropiateStatus] = useState("");

  useEffect(() => {
    const calculateTotalPrice = () => {
      let totalValue = 0;
      restaurant?.subOrders.forEach((subOrder) => {
        subOrder?.itemDetails.forEach((item) => {
          totalValue += (item.basePrice + item.vatInAmount + item.sdInAmount) * item.foodItemQuantity;
          item?.addOns?.forEach((addOn) => {
            totalValue += addOn.addOnBasePrice * addOn.addOnQuantity;
            addOn.options.forEach((option) => {
              totalValue += option.optionBasePrice * option.optionQuantity;
              option.subOptions.forEach((subOption) => {
                totalValue += subOption.subOptionBasePrice;
              });
            });
          });
        });
      });
      setTotal(totalValue.toFixed(2));
    };

    calculateTotalPrice();
  }, [restaurant]);

  const handleToggle = () => {
    setShowAll((prev) => !prev);
  };

  const getAppropiateStatus = (restaurant) => {
    let hasQueue = false;
    let hasPending = false;
    let hasReady = false;
    let hasServed = false;
    let hasPreparing = false;

    restaurant?.subOrders.forEach(subOrder => {
      subOrder?.itemDetails?.forEach(foodItem => {
        if (foodItem.foodStatus === "Queue") hasQueue = true;
        if (foodItem.foodStatus === "Pending") hasPending = true;
        if (foodItem.foodStatus === "Ready") hasReady = true;
        if (foodItem.foodStatus === "Served") hasServed = true;
        if (foodItem.foodStatus === "Preparing") hasPreparing = true;
      });
    });

    if (hasQueue) {
      setAppropiateStatus("Queue");
      return;
    } else if (hasPending) {
      setAppropiateStatus("Pending");
      return;
    } else if (hasReady) {
      setAppropiateStatus("Ready");
      return;
    } else if (hasServed) {
      setAppropiateStatus("Served");
      return;
    } else if (hasPreparing){
      setAppropiateStatus("Preparing");
    }
  };

  useEffect(() => {
    if (restaurant !== null) {
      getAppropiateStatus(restaurant);
    }
  }, [restaurant]);

  return (
    <div className='p-2'>
      <Accordion
      //  key={index} defaultExpanded={index === 0}
      >
        <AccordionSummary className="shadow">
          <div className={`w-100 d-flex align-items-center justify-content-between pending-order-header-container`}>
            <div className='d-flex align-items-center'>
              <div className='pending-order-logo-container'>
                <img src={restaurant.restaurantLogo} alt="logo" />
              </div>

              <div className='d-flex flex-column'>
                {/* <p className='m-0 pending-order-text'>Order Id: {restaurant?.orderId.slice(-6)}</p> */}
                <div className="d-flex align-items-center" style={{ gap: "20px" }}>
                  <span style={{ color: "#371B17", fontSize: "12px", fontWeight: "500" }}>
                    Order Id: {restaurant?.orderId.slice(-6)}
                  </span>
                  <strong style={{ color: "#371B17", fontSize: "10.5px", fontWeight: "400" }}>
                    {new Date(restaurant?.orderDateTime).toLocaleString("en-GB", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "2-digit",
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true,
                    })}
                  </strong>
                </div>
                <p className=' pending-order-restaurant'
                  style={{ ontFamily: 'Poppins', margin: '0', textAlign: 'left', fontSize: '15px', color: "#371B17", fontWeight: "600" }}
                >
                  {restaurant?.restaurantName}
                </p>
              </div>
            </div>

            <div className='d-flex pending-order-status-container'>
              {appropiateStatus && (
                <p className={`m-0 ready-button pending-status-btn ${
                  appropiateStatus === "Queue" ? "queue-status"
                  :
                  appropiateStatus === "Pending"
                    ? "pending-status"
                    : appropiateStatus === "Preparing"
                      ? "preparing-status"
                      : appropiateStatus === "Ready"
                        ? "ready-status"
                        : "preparing-status"
                  }`} style={{ fontSize: '12px' }}>
                  {/* {restaurant?.orderStatus} */}
                  {appropiateStatus}
                </p>
              )}

              <p style={{ fontSize: '14px' }} className='m-0'>£ {restaurant?.total}</p>
            </div>
          </div>
        </AccordionSummary>

        {/* <AccordionDetails className="bg-light mt-2">
          <div className="order-images mb-3">
            {restaurant?.subOrders && (
              <Swiper
                spaceBetween={0}
                slidesPerView={2.4}
                onSlideChange={() => console.log("slide change")}
                onSwiper={(swiper) => console.log(swiper)}
                navigation={true}
                breakpoints={{
                  437: {
                    slidesPerView:
                      restaurant?.subOrders?.[0]?.itemDetails?.length > 1 ? 2 : 1,
                    spaceBetween: 5,
                  },
                  545: {
                    spaceBetween: 12,
                    slidesPerView: 2.4,
                  },
                  768: {
                    slidesPerView: 3,
                  },
                }}
              >
                {restaurant.subOrders
                  ?.flatMap((sub) => sub.itemDetails || [])
                  ?.map((item, idx) => (
                    <SwiperSlide key={idx} className="d-flex justify-content-center">
                      <div className="pending-slider-img-container">
                        <img
                          src={item.foodItemImage}
                          alt={`${restaurant?.orderId}-${idx}`}
                        />
                      </div>
                    </SwiperSlide>
                  ))}
              </Swiper>
            )}
          </div>

          <ProgressBar order={restaurant} />

          <p className="text-center text-secondary mb-0 fw-bold">
            Your order is {restaurant?.orderStatus}.
          </p>
          <p className="text-center text-secondary">Please Wait.</p>

          <div>
            {restaurant?.subOrders
              ?.flatMap((sub) => sub.itemDetails || [])
              ?.slice(0, showAll ? undefined : 2)
              ?.map((item, idx) => (
                <div key={idx} className="order-item mb-3 p-3">
                  <div className="d-flex justify-content-between align-items-center">
                    <h6 className="mb-0 fw-bold">
                      {idx + 1}) {item.foodItemName}{" "}
                      <span className="fw-normal">x{item.foodItemQuantity}</span>
                      <span className="ms-2 text-muted">£{item.basePrice}</span>
                    </h6>
                    <div className="d-flex align-items-center">
                      <span
                        className="status-badge px-3 py-1 me-3"
                        style={{
                          background:
                            item.foodStatus === "Pending"
                              ? "rgba(243, 156, 18, .2)"
                              : item.foodStatus === "Queue"
                              ? "rgba(239, 83, 80, .2)"
                              : item.foodStatus === "Preparing"
                              ? "rgba(41, 128, 185, .2)"
                              : item.foodStatus === "Ready"
                              ? "rgba(39, 174, 96, .2)"
                              : "",
                          color:
                            item.foodStatus === "Pending"
                              ? "rgb(243, 156, 18)"
                              : item.foodStatus === "Queue"
                              ? "rgb(239, 83, 80)"
                              : item.foodStatus === "Preparing"
                              ? "rgb(41, 128, 185)"
                              : item.foodStatus === "Ready"
                              ? "rgb(39, 174, 96)"
                              : "",
                        }}
                      >
                        {item.foodStatus}
                      </span>
                      <span className="fw-bold">£{item.totalFoodItemPrice || item.totalPrice}</span>
                    </div>
                  </div>

                  {item?.addOns?.map(
                    (addOn) =>
                      addOn?.addOnQuantity > 0 && (
                        <div key={addOn.addOnId} style={{ marginLeft: "18px" }}>
                          <h6>
                            {addOn.addOnName} x{addOn.addOnQuantity}
                            <span> £{addOn.addOnBasePrice}</span>
                          </h6>
                          {addOn?.options?.map(
                            (option) =>
                              option?.optionQuantity > 0 && (
                                <div key={option.optionId} style={{ marginLeft: "1rem" }}>
                                  <h6>
                                    {option.optionName} x{option.optionQuantity}
                                    <span> £{option.optionBasePrice}</span>
                                  </h6>
                                  {option?.subOptions?.map((subOption) => (
                                    <div key={subOption.subOptionId} style={{ marginLeft: "2rem" }}>
                                      <span>
                                        {subOption.subOptionName} x1 <span>£{subOption.subOptionBasePrice}</span>
                                      </span>
                                    </div>
                                  ))}
                                </div>
                              )
                          )}
                        </div>
                      )
                  )}
                </div>
              ))}
          </div>

          <div className="payment-breakdown mt-4 p-3 shadow-sm rounded">
            <h6 className="mb-3">Payment Break Downs</h6>
            <ul
              className="list-unstyled"
              style={{
                padding: 0,
                margin: 0,
                fontSize: "14px",
                color: "#555",
              }}
            >
              <li className="d-flex justify-content-between mb-2">
                <span>Sub Total</span> <span>£{restaurant?.subTotal}</span>
              </li>
              <li className="d-flex justify-content-between mb-2">
                <span>Total VAT Inc. SD</span> <span>£{restaurant?.totalVatIncSd}</span>
              </li>
              <li className="d-flex justify-content-between mb-2">
                <span>Total Service Charge Exc. VAT</span>{" "}
                <span>£{restaurant?.totalServiceChargeExcVat}</span>
              </li>
              <li className="d-flex justify-content-between mb-2">
                <span>Total Tips</span> <span>£{restaurant?.totalTips}</span>
              </li>
              <li className="d-flex justify-content-between mb-2">
                <span>Delivery Fee Inc. VAT (20%)</span>{" "}
                <span>£{restaurant?.deliveryFeeIncVat}</span>
              </li>
              <li className="d-flex justify-content-between mb-2">
                <span>Credit</span> <span>£{restaurant?.credit}</span>
              </li>
            </ul>
            <hr />
            <div>
              <h6 className="d-flex justify-content-between">
                <div className="d-flex flex-column">
                  <h6 className="bold-text">Total Price</h6>
                  <span className="fs-6">(VAT Inc.)</span>
                </div>
                <h6 className="bold-text">£{restaurant?.total}</h6>
              </h6>
            </div>
          </div>
          
          {restaurant?.subOrders?.flatMap((s) => s.itemDetails || []).length > 2 && (
            <div className="text-center">
              <button className="see-more-btn" onClick={handleToggle}>
                {showAll ? "See Less" : "See More"}
                {showAll ? <FaAngleDoubleUp /> : <FaAngleDoubleDown />}
              </button>
            </div>
          )}

        </AccordionDetails> */}


        <AccordionDetails className="bg-light mt-2">
          {restaurant?.subOrders?.map(
            (item) =>
              item?.itemDetails.slice(0, showAll ? item.itemDetails.length : 2).map(foodItem => <div>
                <div
                  className='d-flex mt-3 cartdetailsGrid justify-content-between align-items-center pendingcartdetailsGrid '
                  style={{ cursor: 'pointer', padding: '0 14px' }}
                >
                  <Link
                    to={{
                      pathname: '/checkout',
                    }}
                    className='d-flex align-items-center text-decoration-none itemDetailsAndImage'
                  >
                    <div className="cart-item-image">
                      <img
                        src={foodItem?.foodItemImage}
                        alt=''
                        style={{ height: '4.5rem' }}
                      />
                    </div>
                    <div className='d-flex productDetails justify-content-center ps-2 pb-2'>

                      <h5>{foodItem?.foodItemName}
                        <span className={restaurant?.orderStatus === "Queue"
                          ?
                          "queue-status"
                          :
                          restaurant?.orderStatus === "Pending"
                            ? "pending-status"
                            : restaurant?.orderStatus === "Preparing"
                              ? "preparing-status"
                              : restaurant?.orderStatus === "Ready"
                                ? "ready-status"
                                : "preparing-status"
                        } style={{ fontSize: '12px', backgroundColor: '#e3e9ff', color: '#5a7dff', borderRadius: '20px', cursor: 'pointer', boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)', padding: '3px 5px', marginLeft: '5px' }}
                        >{foodItem?.foodStatus}</span>
                      </h5>

                      <div className='options addOnCart text-secondary-emphasis' >
                        {foodItem?.addOns?.map((addOn) => {
                          return (
                            addOn?.addOnQuantity > 0 && (
                              <h6 key={addOn.addOnId} >
                                {addOn.addOnName} x{addOn.addOnQuantity}
                                <span> £{addOn.addOnBasePrice} </span>
                                <br />
                              </h6>
                            )
                          )
                        })}
                        {foodItem?.addOns?.map((addOn) => addOn.options.map(option => {
                          return (
                            option?.optionQuantity > 0 && (
                              <h6 key={option.optionId} style={{ marginLeft: "1rem" }}>
                                {option.optionName} x{option.optionQuantity}
                                <span> £{option.optionBasePrice} </span>


                                {option?.subOptions?.map((suboption) => {
                                  return (
                                    <span
                                      className='span-text'
                                      key={suboption.orderSubOptionId}
                                    >
                                      ({suboption.subOptionName} x
                                      {1} £
                                      {suboption.subOptionBasePrice})
                                    </span>
                                  );
                                })}
                                <br />
                              </h6>
                            )
                          );
                        }))}
                      </div>
                    </div>
                  </Link>
                  <div> <p className='price d-flex justify-content-end pendingPrice'> £{restaurant?.total}</p> </div>
                </div>
              </div>)
          )}

          {restaurant?.subOrders?.flatMap((s) => s.itemDetails || []).length > 2 && (
            <div className="text-center">
              <button className="see-more-btn" onClick={handleToggle}>
                {showAll ? "See Less" : "See More"}
                {showAll ? <FaAngleDoubleUp /> : <FaAngleDoubleDown />}
              </button>
            </div>
          )}

          <div className="payment-breakdown mt-4 p-3 shadow-sm rounded">
            <h6 className="mb-3">Payment Break Downs</h6>
            <ul
              className="list-unstyled"
              style={{
                padding: 0,
                margin: 0,
                fontSize: "14px",
                color: "#555",
              }}
            >
              <li className="d-flex justify-content-between mb-2">
                <span>Sub Total</span> <span>£{restaurant?.subTotal}</span>
              </li>
              <li className="d-flex justify-content-between mb-2">
                <span>Total VAT Inc. SD</span> <span>£{restaurant?.totalVatIncSd}</span>
              </li>
              <li className="d-flex justify-content-between mb-2">
                <span>Total Service Charge Exc. VAT</span>{" "}
                <span>£{restaurant?.totalServiceChargeExcVat}</span>
              </li>
              <li className="d-flex justify-content-between mb-2">
                <span>Total Tips</span> <span>£{restaurant?.totalTips}</span>
              </li>
              <li className="d-flex justify-content-between mb-2">
                <span>Delivery Fee Inc. VAT (20%)</span>{" "}
                <span>£{restaurant?.deliveryFeeIncVat}</span>
              </li>
              <li className="d-flex justify-content-between mb-2">
                <span>Credit</span> <span>£{restaurant?.credit}</span>
              </li>
            </ul>
            <hr />
            <div>
              <h6 className="d-flex justify-content-between">
                <div className="d-flex flex-column">
                  <h6 className="bold-text">Total Price</h6>
                  <span className="fs-6">(VAT Inc.)</span>
                </div>
                <h6 className="bold-text">£{restaurant?.total}</h6>
              </h6>
            </div>
          </div>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default PendingCartOrderNew;
